import React from 'react';
import { Box } from 'lmc-ui-library';
import { Field } from 'formik';
import TextField from 'modules/af_cm_ui_kit/components/TextField/TextField';
import { FIELDS, FIELDS_LABELS } from 'screens/Panel/screens/User/screens/Edit/Edit.types';

import styles from 'screens/Panel/screens/User/screens/Edit/Edit.module.scss';

const Account: React.FC = () => {
  return (
    <Box title="Account" className={styles.box}>
      <Box.Content>
        <Field component={TextField} name={FIELDS.FULL_NAME} title={FIELDS_LABELS.FULL_NAME} disabled={true} />

        <Field component={TextField} name={FIELDS.COMPANY} title={FIELDS_LABELS.COMPANY} disabled={true} />

        <Field component={TextField} name={FIELDS.FCA_NUMBER} title={FIELDS_LABELS.FCA_NUMBER} disabled={true} />
      </Box.Content>
    </Box>
  );
};

export default Account;
